// Capitalise each part of a name (handles "jane smith", "mary-jane o'brien").
// Only raises letters — never lowers — so "McDonald" and ALL-CAPS input survive.
export function titleCase(str) {
  return (str || '').replace(/(^|[\s\-'])([a-z])/g, (m, sep, ch) => sep + ch.toUpperCase());
}
